export const tipCalloutStyles = `
  @font-face {
    font-family: 'ProximaSoft-Regular';
    src: url('https://s3.amazonaws.com/tide-assets/proxima-soft.eot');
    src: url('https://s3.amazonaws.com/tide-assets/proxima-soft.eot?#iefix') format('embedded-opentype'),
               url('https://s3.amazonaws.com/tide-assets/proxima-soft.woff2') format('woff2'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft.woff') format('woff'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft.ttf') format('truetype'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft.svg#youworkforthem') format('svg');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'ProximaSoft-Semibold';
    src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.eot');
    src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.eot?#iefix') format('embedded-opentype'),
               url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.woff2') format('woff2'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.woff') format('woff'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.ttf') format('truetype'),
         url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.svg#youworkforthem') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  div, p, span {
    font-size: 16px;
    color: black;
    font-family: "ProximaSoft-Regular";
  }
  
  strong {
   font-weight: bold;
   font-family: "ProximaSoft-Semibold";
  }
  
  .article-callout-paragraph-container {
    margin: 15px 0;
    display: flex;
    flex-direction: row;
    border-left: 10px solid;
    border-radius: 3px;
    width: 100%;
    position: relative;
    padding: 10px 15px;
    color: black;
  }
  
  .article-callout-paragraph-container p {
    margin: 0;
  }
  
  pre {
    white-space: pre-wrap;
    background-color: #FAFAFA;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 12px;
  }
  
  .article-callout-paragraph-container--info {
    border-color: #9EDCF7;
    background-color: #F5FBFE;
    font-family: "ProximaSoft-Regular";
  }
  
  .article-callout-paragraph-container--note {
    border-color: #FEF79E;
    background-color: #FFFCD9;
  }
  
  .article-callout-paragraph-container--warning {
    border-color: #E6314F;
    background-color: #FCE0E5;
  }
  
  .article-callout-paragraph-container--info .article-callout-icon-wrapper {
    background-color: #9EDCF7;
  }
  
  .article-callout-paragraph-container--note .article-callout-icon-wrapper {
    background-color: #FEF79E;
  }
  
  .article-callout-paragraph-container--warning .article-callout-icon-wrapper {
    background-color: #E6314F;
  }
  
  .article-callout-icon-wrapper {
    flex-shrink: 0;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .article-callout-paragraph-container--info .article-callout-textarea {
    background-color: #F5FBFE;
  }
  
  .article-callout-paragraph-container--note .article-callout-textarea {
    background-color: #FFFCD9;
  }
  
  .article-callout-paragraph-container--warning .article-callout-textarea {
    background-color: #FCE0E5;
  }
  
  img {
    max-width: 100%;
    height: auto;
    margin: 30px auto;
    display: block;
  }
  
  .mce-content-body a[href] {
    color: #0A5BFF;
    text-decoration: none;
  }
  
  .mce-content-body h2 {
    color: #394F5A;
    padding-top: 30px;
    border-top: 1px solid #E1EEF4;
    line-height: 1.2;
    font-weight: bold;
    font-size: 24px;
    font-family: "ProximaSoft-Regular";
  }
  
  .mce-content-body h3 {
    color: #394F5A;
    line-height: 1.2;
    font-weight: bold;
    font-size: 18px;
    font-family: "ProximaSoft-Regular";
  }
  
  .embedded-video {
    border: 0;
  }
  
  .article-callout-textarea {
    border: none;
    width: 100%;
    resize: none;
    padding: 10px 15px;
    margin: 0 !important;
    border-radius: 0 3px 3px;
    font-size: 16px;
    line-height: 20px;
    outline: none;
    color: #333;
    flex: 1;
    flex-shrink: 0;
  }

  code[class*="language-"],
  pre[class*="language-"] {
    font-size: 16px;
  }

  .mce-content-body ul li {
    margin-left: 0;
    margin-bottom: 0;
    color: #000000;
  }

  .mce-content-body ul {
    padding-left: 40px;
    font-size: 16px;
    font-family: 'ProximaSoft-Regular';
    line-height: 1.3;
  }
`